// Convert absolute OS paths to file links without interpreting #, ? or % as URL syntax.
export function patternLocation(value) {
  const raw = String(value || '').trim();
  if (!raw) return { raw, href: null, local: false };
  const encodePath = (path) => path.split('/').map(encodeURIComponent).join('/');
  try {
    if (/^[a-z]:[\\/]/i.test(raw)) {
      const path = raw.replace(/\\/g, '/');
      return { raw, href: `file:///${path.slice(0, 2)}${encodePath(path.slice(2))}`, local: true };
    }
    if (/^(\\\\|\/\/)/.test(raw)) {
      const path = raw.replace(/\\/g, '/').slice(2);
      const slash = path.indexOf('/');
      if (slash < 1) return { raw, href: null, local: true };
      const host = path.slice(0, slash);
      if (!/^[\w.-]+$/.test(host)) return { raw, href: null, local: true };
      return { raw, href: `file://${host}${encodePath(path.slice(slash))}`, local: true };
    }
    if (raw.startsWith('/')) return { raw, href: `file://${encodePath(raw)}`, local: true };
    const url = new URL(raw);
    if (!['http:', 'https:', 'file:'].includes(url.protocol)) return { raw, href: null, local: false };
    if (url.username || url.password) return { raw, href: null, local: false };
    return { raw, href: url.href, local: url.protocol === 'file:' };
  } catch {
    return { raw, href: null, local: false };
  }
}
